module.exports = __webpack_public_path__ + "static/media/outlier_logo.73183fae.png";